/* unplugin-vue-components disabled */import script from "./TeacherContribute.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherContribute.vue?vue&type=script&setup=true&lang=js"

import "./TeacherContribute.vue?vue&type=style&index=0&id=87d2b86c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87d2b86c"]])

export default __exports__